import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import classNames from 'classnames/bind';
import noop from 'lodash/noop';
import React, { useRef, useMemo } from 'react';
import { useClickAway } from 'react-use';
import '../bottomNavigationBar/BottomNavigationBar.js';
import '../button/ButtonBox.js';
import '../button/ButtonBoxCombined.js';
import '../button/ButtonBoxDouble.js';
import '../flexibleLayout/FlexibleLayout.js';
import '../footer/Footer.js';
import '../footer/FooterInfo.js';
import '../footer/FooterQuickMenu.js';
import '../header/Divider.js';
import '../header/HeaderBrandDepth.js';
import '@babel/runtime-corejs3/core-js-stable/object/keys';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import '@babel/runtime-corejs3/core-js-stable/instance/filter';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import '@babel/runtime-corejs3/core-js-stable/object/define-property';
import '@babel/runtime-corejs3/helpers/defineProperty';
import '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import '../header/CommonHeader.js';
import '../header/HeaderName.js';
import '../header/HeaderNpayButton.js';
import '@babel/runtime-corejs3/core-js-stable/array/is-array';
import '../header/HeaderBrandWindow.js';
import '../header/HeaderWindow.js';
import '../header/HeaderBack.js';
import '../loading/Loading.js';
import '../loading/LoadingBasic.js';
import '../loading/LoadingCube.js';
import '../rollingAnimation/RollingAnimation.js';
import '../skeleton/SkeletonArea.js';
import '../skeleton/SkeletonCard.js';
import '../skeleton/SkeletonListImage.js';
import '../skeleton/SkeletonListSymbol.js';
import '../skeleton/SkeletonListText.js';
import '../skipNavigation/SkipNavigation.js';
import '../stickyHeaderArea/StickyHeaderAreaInner.js';
import '../stickyHeaderArea/StickyHeaderContentArea.js';
import '../tab/LineTab.js';
import '../tab/SolidTab.js';
import '@babel/runtime-corejs3/core-js-stable/instance/slice';
import '../input/InputArea.js';
import '@babel/runtime-corejs3/core-js-stable/instance/concat';
import '@babel/runtime-corejs3/core-js-stable/instance/pad-start';
import '@babel/runtime-corejs3/core-js-stable/instance/index-of';
import '../../constants/bottomNavigationBar.js';
import { CHIP_TYPE, CHIP_VARIANT, CHIP_COUNT_COLOR, CHIP_STYLE_STATE } from '../../constants/chip.js';
import '../../constants/footer.js';
import '../../constants/footerQuickMenuItem.js';
import '../../constants/global.js';
import 'lodash/isString';
import '../input/InputLineAmount.js';
import '@babel/runtime-corejs3/core-js-stable/object/entries';
import '@babel/runtime-corejs3/core-js-stable/instance/map';
import './ChipsGroup.js';
import 'lodash/isEmpty';
import '@financial/common-hooks';
import '../modal/bottomModalNotice/BottomModalNotice.js';
import '../modal/centerModal/CenterModalContents.js';
import '../modal/centerModal/CenterModalWrapper.js';
import '../toast/ToastAction.js';
import '../toast/ToastNotice.js';
import '../header/buttons/BenefitButton.js';
import '../header/HeaderButton.js';
import '@babel/runtime-corejs3/core-js-stable/instance/fill';
import '../header/buttons/TextButton.js';
import IcButtonCheckLineBoldOff from '../icons/IcButtonCheckLineBoldOff.js';
import IcTxtArrowDownSmallThin from '../icons/IcTxtArrowDownSmallThin.js';
import COLOR from '../../foundation/color.js';
import styles from './Chip.module.scss.js';

var cx = _bindInstanceProperty(classNames).call(classNames, styles);
function getRandomString() {
  return (Math.random() + 1).toString(36).substring(2);
}
/**
 * ## Chip
 *
 * > 🚨 Chip 컴포넌트는 단독으로 사용할 수 없습니다!!
 *
 * `radio`, `checkbox`, `select` 의 용도로 사용할 수 있으며, 다음과 같이 대응됩니다.
 * - radio: `ChipMenu` (`onChange` 핸들러 사용)
 * - checkbox: `ChipCheck` (`onChange` 핸들러 사용)
 * - select: `ChipSelect` (`onClick` 핸들러 사용)
 *
 * ```tsx
 * <Chip type={CHIP_TYPE.MENU} onChange={onChange}>선택</Chip>
 * <Chip type={CHIP_TYPE.CHECK} onChange={onChange}>선택</Chip>
 * <Chip type={CHIP_TYPE.SELECT} onClick={onClick}>선택</Chip>
 * ```
 *
 * 스타일의 경우 `Fill Type`, `Stroke Type` 두 가지가 있습니다.
 * Chip 이 활성화된 상태에서는 디자인 차이가 없지만, 비활성화 상태 및 disabled 일 때 디자인 차이가 있습니다.
 *
 * ```tsx
 * <Chip type={CHIP_TYPE.MENU} variant={CHIP_VARIANT.FILL}>선택</Chip>
 * <Chip type={CHIP_TYPE.MENU} variant={CHIP_VARIANT.STROKE}>선택</Chip>
 * ```
 *
 */
function Chip(_ref) {
  var content = _ref.content,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? getRandomString() : _ref$id,
    name = _ref.name,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? CHIP_TYPE.MENU : _ref$type,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? CHIP_VARIANT.FILL : _ref$variant,
    count = _ref.count,
    _ref$countColor = _ref.countColor,
    countColor = _ref$countColor === void 0 ? CHIP_COUNT_COLOR.GREEN : _ref$countColor,
    active = _ref.active,
    focused = _ref.focused,
    disabled = _ref.disabled,
    selector = _ref.selector,
    onClick = _ref.onClick,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur;
  var chipsRef = useRef(null);
  var styleState = useMemo(function () {
    if (disabled) {
      return CHIP_STYLE_STATE.DISABLED;
    }
    if (type === CHIP_TYPE.MENU) {
      if (active) {
        return CHIP_STYLE_STATE.ACTIVE;
      }
      return CHIP_STYLE_STATE.DEACTIVE;
    }
    if (type === CHIP_TYPE.CHECK) {
      if (active) {
        return CHIP_STYLE_STATE.FOCUS;
      }
      return CHIP_STYLE_STATE.DEACTIVE;
    }
    if (type === CHIP_TYPE.SELECT) {
      if (focused) {
        return CHIP_STYLE_STATE.FOCUS;
      }
      if (active) {
        return CHIP_STYLE_STATE.ACTIVE;
      }
    }
    return CHIP_STYLE_STATE.DEACTIVE;
  }, [disabled, type, active, focused]);
  var _useMemo = useMemo(function () {
      if (styleState === CHIP_STYLE_STATE.DISABLED) {
        return [COLOR.gray300.color, COLOR.gray300.color];
      }
      if (styleState === CHIP_STYLE_STATE.FOCUS) {
        return [COLOR.gray800.color, COLOR.gray800.color];
      }
      if (styleState === CHIP_STYLE_STATE.ACTIVE) {
        return [COLOR.white.color, COLOR.white.color];
      }
      return [COLOR.gray500.color, COLOR.gray700.color];
    }, [styleState]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    icButtonCheckFill = _useMemo2[0],
    icTxtArrowDownFill = _useMemo2[1];
  var inputType = useMemo(function () {
    if (type === CHIP_TYPE.CHECK) {
      return 'checkbox';
    }
    if (type === CHIP_TYPE.MENU) {
      return 'radio';
    }
  }, [type]);
  var Wrapper = function Wrapper(_ref2) {
    var chipInner = _ref2.children;
    return /*#__PURE__*/React.createElement(React.Fragment, null, type === CHIP_TYPE.SELECT ? ( /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: cx('article', variant, styleState),
      disabled: disabled,
      onClick: onClick
    }, chipInner)) : ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
      type: inputType,
      id: id,
      name: name,
      className: cx('hidden'),
      checked: active,
      disabled: disabled,
      onChange: onChange || noop,
      onClick: function onClick(e) {
        return active && inputType === 'radio' && (onChange === null || onChange === void 0 ? void 0 : onChange(e));
      }
    }), /*#__PURE__*/React.createElement("label", {
      htmlFor: id,
      className: cx('article', variant, styleState)
    }, chipInner))));
  };
  useClickAway(chipsRef, function () {
    return focused && (onBlur === null || onBlur === void 0 ? void 0 : onBlur());
  }, ['mousedown']);
  return /*#__PURE__*/React.createElement("div", {
    ref: chipsRef
  }, /*#__PURE__*/React.createElement(Wrapper, null, type === CHIP_TYPE.CHECK && ( /*#__PURE__*/React.createElement("span", {
    className: cx('icon', 'check')
  }, /*#__PURE__*/React.createElement(IcButtonCheckLineBoldOff, {
    width: "12",
    height: "12",
    fill: icButtonCheckFill
  }))), content, count !== undefined && ( /*#__PURE__*/React.createElement("span", {
    className: cx('count', !disabled && countColor && "color-".concat(countColor))
  }, count)), type === CHIP_TYPE.SELECT && ( /*#__PURE__*/React.createElement("span", {
    className: cx('icon', 'select')
  }, /*#__PURE__*/React.createElement(IcTxtArrowDownSmallThin, {
    width: "10",
    height: "6",
    fill: icTxtArrowDownFill
  })))), focused && selector);
}

export { Chip as default };
